import React, { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import restFactory from 'v2/utils/restFactory';
import { Spinner } from 'react-bootstrap';
import { fetchUserObject } from 'actions';
import { useDispatch } from 'react-redux';

const ConfirmEmailVerification = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { mutate: confirmEmailVerification } = useMutation(
    async () => {
      return await restFactory.get(
        `/dj/api/v1/strapi_user/email_verification_status/`
      );
    },
    {
      onSettled: () => {
        dispatch(fetchUserObject());
        history.push('/');
      },
    }
  );

  useEffect(() => {
    confirmEmailVerification();
  }, []);

  return (
    <div className="loadingIndicatorContainer">
      <Spinner animation="border" />
    </div>
  );
};

export default ConfirmEmailVerification;
